<template>
  <div style="position:relative;">
    <!-- <v-card> -->
      <v-layout row wrap style="position:fixed; width:100%; max-width:480px; height: 50px; background:white; z-index:100; padding-bottom: 15px; border: 1px solid #f5f5f5">
      <v-flex xs10 style="
              padding-left: 25px;
              font-weight: bold;
              font-size: 19px;
              cursor: pointer;
              text-align: left;
              padding-top: 10px;
              color: #10aa85;
            ">
        <v-icon color="#10AA85" style="margin-right: 20px" @click="$router.push('/profile')">
          arrow_back
        </v-icon>
        Affiliate
      </v-flex>
      <v-flex xs2 style="padding-top: 10px; text-align: right">
        <v-icon color="#10AA85" style="margin-right: 20px" @click="$router.push('/affiliate-faq')">
          info
        </v-icon>
      </v-flex>
    </v-layout>
    <v-layout row wrap style="padding-top:50px;">
      <v-container>
        <v-layout row wrap>
          <v-flex xs2 style="display: flex; align-items: center; justify-content: center">
            <img :src="profile.picture" alt="image-alt" style="width: 35px; border-radius:50%;" />
          </v-flex>
          <v-flex xs10 style="display: flex; flex-flow: column">
            <span>Selamat Datang,</span>
            <b>{{ profile.name }}</b>
          </v-flex>
        </v-layout>
        <v-layout row wrap style="margin-top: 20px">
          <v-flex xs2 style="display: flex; align-items: center; justify-content: center">
            <img src="@/assets/icon/affiliate/ic_koinfj.svg" alt="image-alt" style="width: 35px" />
          </v-flex>
          <v-flex xs6 style="display: flex; flex-flow: column">
            <span>Koin Juara</span>
            <b style="color: #00ade2; font-size: 18px">{{ affData.total_coin | currency }}</b>
          </v-flex>
          <v-flex xs4>
            <v-btn @click="$router.push('/affiliate-redeem')" outline color="#00ade2" round block> Tarik Saldo </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container style="padding:0px 25px 100px 25px;">
        <v-layout row wrap>
          <v-flex xs12>
            <h3>Pendapatan</h3>
          </v-flex>
          <v-flex xs12 style="display:flex; flex-flow:row;align-items:center;">

            <p style="margin-bottom:0px;">
              Total Akumulasi Koin:
            </p>
            <div style="background-color:#f3f3f3; border-radius:20px; padding:5px 15px 5px 15px; margin-left: 10px;">
              <b style="color: #00ade2">
                {{ affData.accumulation_coin | currency }}
              </b>
            </div>
          </v-flex>
          <v-flex xs12 style="display: flex; align-items: center; cursor: pointer; margin: 10px 0px 10px 0px;"
            @click="$router.push('/affiliate-trx')">
            <img src="@/assets/icon/affiliate/transactions.svg" alt="image-alt" style="width: 20px" />
            <b style="color: #10aa85">Transaksi Affiliate</b>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="affData.affiliate_links.length === 0">
          <v-flex xs12 style="
                  display: flex;
                  flex-flow: column;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                ">
            <img src="@/assets/icon/affiliate/ic_empty.svg" alt="image-alt" style="width: 55px; margin: 35px" />
            <p>
              Belum ada produk premium NF Juara yang kamu promosikan. Yuk mulai tambah
              uang jajan sekarang!
            </p>
          </v-flex>
          <v-flex xs12>
            <v-btn color="#10aa85" dark block round large @click="$router.push('/premium?afdash=true')"> Ke Premium </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="affData.affiliate_links.length > 0" row wrap>
          
          <v-flex xs12 v-for="item in affData.affiliate_links" :key="item">
            <div class="product-box">
              <v-layout row wrap>
                <v-flex xs11 style="margin-bottom: 15px">
                  <h3>{{ item.product.title }}</h3>
                </v-flex>
                <v-flex xs1 style="text-align: right">
                  <v-icon v-if="item.product_link !== null" @click="share(item.product)" color="#10aa85" style="cursor:pointer;"> share </v-icon>
                </v-flex>
                <v-flex xs8 style="margin-bottom: 5px">
                  <span style="color: #eb5757; font-weight: bold"> Rp {{ item.product.net_price | currency }} </span>
                </v-flex>
                <v-flex xs4 style="text-align: right">
                  <span>Dibeli: <b style="color: #10AA85">{{ item.total_usage }} Kali</b></span>
                </v-flex>
                <v-flex xs8>
                  <span> Komisi Affiliate : </span>
                </v-flex>
                <v-flex xs4 style="text-align: right">
                  <span><b>{{ item.product.coin_commission | currency }} Koin</b></span>
                </v-flex>
                <v-flex xs12 style="
                        border-top: 1px solid lightgray;
                        padding-top: 10px;
                        display: flex;
                        justify-content: space-between;
                        margin-top: 10px;
                      ">
                  <b>Subtotal Komisi:</b>
                  <b style="color: #00ade2">{{ item.accumulation_coin | currency }}</b>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="submit" v-if="affData.affiliate_links.length > 0">
        <v-btn round block color="#10aa85" dark @click="$router.push('/premium?afdash=true')">
          Bagikan Produk Lain
        </v-btn>
      </div>
    </v-layout>
  </div>
</template>
<style>
.submit {
  position: fixed;
  bottom: 0;
  margin-bottom: 0px;
  margin-top: 0px;
  max-width: 480px;
  background-color: white;
  width: 100%;
  border-top: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
  padding: 15px;
  justify-content: center;
}
.product-box {
  padding: 15px;
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 14px 0px 0px 0px;
}
</style>
<script>
export default {
  name: "affiliate-registration",
  data() {
    return {
      profile: null,
      affiliateProducts: [0, 0],
      affData: { total_coin: null, accumulation_coin: null, affiliate_links: []},
    };
  },
  filters: {
    currency(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    share(item) {
      this.$store.dispatch("funcGetLinkProduct", item.id).then((response) => {
        this.$store.commit('setShareAffiliate', response.data)
      }).catch((err) => {
        // var error = JSON.parse(JSON.stringify(err))
        // if(error.message === 'Request failed with status code 409') {
        //   this.$router.push('/affiliate-r?pid='+ item.id)
        // }
      })
    },
  },
  mounted() {
    this.profile = JSON.parse(sessionStorage.profile);
    this.$store.dispatch("funcGetDashboardAffiliate").then((response) => {
      this.affData = response.data
    }).catch((err) => {
      var error = JSON.parse(JSON.stringify(err))
      if (error.message === 'Request failed with status code 404') {
        this.$router.push("/affiliate-r");
      }
    })
  },
};
</script>
